
import { Vue, Component, Prop, toNative } from 'vue-facing-decorator';
import SideBarListings from './SideBarListings.vue';
import EmailCategoriesModel from '@/entities/Invite/EmailCategoriesModel';
import InviteEmailCategoryTypeEnum from '@/enums/InviteEmailCategoryTypeEnum';

@Component({
  components : {
    SideBarListings,
  },
})

class SideBarPane extends Vue{
  @Prop() private emailCategories!: EmailCategoriesModel[];
  @Prop({default : ''}) currentSelectedTab!: string;

  private isMobile = false;

  // Categorize the side bar emails data to ticketed , free , and other events
  public get categorizedListings(): EmailCategoriesModel[][] {
    return this.emailCategories.reduce((categoryGrouped: EmailCategoriesModel[][], template: EmailCategoriesModel) => {
      if(template.Category === InviteEmailCategoryTypeEnum.NonTicketed){
        categoryGrouped[0].push(template);
      } else if (template.Category === InviteEmailCategoryTypeEnum.Ticketed){
        categoryGrouped[1].push(template);
      } else {
        categoryGrouped[2].push(template);
      }
      return categoryGrouped;
    }, [[], [], []]);
  }

  private mounted(){
    if(window.innerWidth <= 767){
      this.isMobile = true;
    }else{
      this.isMobile = false;
    }
  }

}
export default toNative(SideBarPane);
